import {
  FILE_TYPE,
  HEADING_TYPE,
  SELECT_TYPE,
  TEXT_TYPE,
  TEXT_VIEW_TYPE,
} from "../../constants/webapp";

export const useTicketsForm = () => {
  const formFields = [
    {
      type: HEADING_TYPE,
      text: "Create Inquiry Ticket",
    },
    {
      type: TEXT_VIEW_TYPE,
      text: "Please describe your inquiry or issue to be resolved before continuing to submit the ticket.",
    },
    {
      id: "email",
      label: "Email Address",
      type: TEXT_TYPE,
      required: true,
      props: {
        helperText:
          "Your email is needed to send you the progress and feedback about your issue.",
        type: "email",
      },
    },
    {
      label: "Topic",
      type: TEXT_TYPE,
      required: true,
      props: {
        placeholder: "Outline the topic of your issue",
      },
    },
    {
      label: "Description",
      type: TEXT_TYPE,
      required: true,
      props: {
        rows: 4,
        placeholder: "Provide details of your issue or inquiry",
      },
    },
    {
      label: "Priority",
      type: SELECT_TYPE,
      options: [
        { id: 1, name: "High" },
        { id: 2, name: "Moderate" },
        { id: 3, name: "Low" },
      ],
      required: true,
    },

    {
      label: "Attach Screenshot",
      type: FILE_TYPE,
      props: {
        optional: true,
        limit: 2,
        size: 1,
      },
    },
  ];
  return { formFields };
};
